import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import DestinationsPage from './pages/DestinationsPage';
import ScrollToTop from './components/ScrollToTop';
import ItineraryPage from './pages/Itinerary';
import PrivacyWithStyles from './pages/Privacy';
import AboutPage from './pages/AboutPage';
import AdminPage from './pages/admin';
import TripsPage from './pages/TripsPage';
import Contact from './pages/Contact'; // added import
import Policy from './pages/Policy'; // add this import

// Removed App.css import to prevent style conflicts
function App() {
  return (
    // Removed the "App" className to prevent any CSS conflicts
    <Router>
      <div>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/destinations" element={<DestinationsPage />} />
          <Route path="/destinations/:destinationName" element={<DestinationsPage />} />
          <Route path="/itinerary/:id" element={<ItineraryPage />} />
          <Route path="/trips" element={<TripsPage />} />
          <Route path="/trips/:category" element={<TripsPage />} />
          <Route path="/privacy" element={<PrivacyWithStyles />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/contact" element={<Contact />} /> {/* added route */}
          <Route path="/policy" element={<Policy />} /> {/* add this route */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
